import { render, staticRenderFns } from "./flex-event-editor.vue?vue&type=template&id=fafe872e&scoped=true&"
import script from "./flex-event-editor.vue?vue&type=script&lang=js&"
export * from "./flex-event-editor.vue?vue&type=script&lang=js&"
import style0 from "./flex-event-editor.vue?vue&type=style&index=0&id=fafe872e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe872e",
  null
  
)

export default component.exports